import * as React from 'react';
import ISubmenuIcon from './ISubmenuIcon';

import * as style from './SubmenuIconStyle.module.scss'

const SubmenuIcon: React.SFC<ISubmenuIcon> = (props) => {
  const { icon } = props;

  return (
    <i className={style.icon}>
      <svg className="svg-icon svg-icon--violet svg-icon--stroke4 svg-icon--size50">
        <use xlinkHref={`#icon-${icon}`} />
      </svg>
    </i>
  );
};

export default SubmenuIcon;
